export const notificationDrawer = {
  notificationDrawerTitle: "Kennisgewings",
  notificationDrawerDeleteBtn: "Verwyder",
  notificationDrawerDeletedNotification: "Kennisgewing verwyder",
  notificationDrawerDeletedFailed: "Kon nie kennisgewing verwyder nie",
  notificationMarkReadFailed: "Kon nie kennisgewing as gelees merk nie",
  notificationDrawerNotifications: "Geen kennisgewings",
  notificationDrawerPlay: "Speel",
  notificationDrawerPlayGame: "Gaan na speletjie",
  notificationClose: "Sluit",
  notificationJustNow: "So pas",
  notificationMarkRead: "Merk as gelees",
  notificationTagNews: "Nuus",
  notificationTagPush: "Waarskuwing",
  notificationTagBreaking: "Promosies en meer",
  notificationTagMovement: "Transaksie",
  notificationTab_all: "Alles",
  notificationTab_news: "Nuus",
  notificationTab_breaking: "Promosies en meer",
  notificationTab_movements: "Transaksies",
  notificationEmptySubtext: "Wanneer jy nuwe kennisgewings het, sal hulle hier verskyn",
  notificationNewsCta: "Klik om meer te leer",
};
